module.exports = __webpack_public_path__ + "img/ico_badge07.15f88ac8.svg";